import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/* istanbul ignore file */

import React from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { IconHeartOutlined } from "../../foundations/Iconography/IconHeartOutlined";
import { IconHeartSolid } from "../../foundations/Iconography/IconHeartSolid";
import { OutlineButton } from "../Button/OutlineButton/OutlineButton";
import { FAVOURITE_BUTTON_CLASSNAME, FAVOURITE_ICON_TRANISITION_DURATION_IN_MS, FAVOURITE_TRANSITION_CLASSNAME } from "./constants/favouriteButton";
import * as styles from "./FavouriteButton.styles";
export var FavouriteButton = function FavouriteButton(_ref) {
  var active = _ref.active,
    className = _ref.className,
    iconStyles = _ref.iconStyles,
    onClick = _ref.onClick,
    size = _ref.size;
  var iconSize = size === 'small' ? 16 : 24;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.favouriteIconTransition
  }, /*#__PURE__*/React.createElement(SwitchTransition, {
    mode: "in-out"
  }, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: FAVOURITE_TRANSITION_CLASSNAME,
    in: active,
    key: "".concat(FAVOURITE_TRANSITION_CLASSNAME, "-").concat(active),
    timeout: FAVOURITE_ICON_TRANISITION_DURATION_IN_MS
  }, /*#__PURE__*/React.createElement(_StyledOutlineButton, {
    "aria-label": "Favourite",
    "aria-pressed": active,
    className: className ? "".concat(FAVOURITE_BUTTON_CLASSNAME, " ").concat(className) : FAVOURITE_BUTTON_CLASSNAME,
    onClick: onClick,
    type: "button",
    $_css2: [styles[size], styles.favouriteButton]
  }, active ? /*#__PURE__*/React.createElement(_StyledIconHeartSolid, {
    color: "var(--brand-purple-base)",
    height: iconSize,
    width: iconSize,
    $_css3: iconStyles
  }) : /*#__PURE__*/React.createElement(_StyledIconHeartOutlined, {
    color: "var(--brand-purple-base)",
    height: iconSize,
    width: iconSize,
    $_css4: iconStyles
  })))));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledOutlineButton = _styled2(OutlineButton)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledIconHeartSolid = _styled3(IconHeartSolid)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledIconHeartOutlined = /*#__PURE__*/_styled4(IconHeartOutlined).withConfig({
  displayName: "FavouriteButton___StyledIconHeartOutlined",
  componentId: "sc-11nndtv-0"
})(["", ""], function (p) {
  return p.$_css4;
});